import React, { useEffect, useState, useRef } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import useSocket from "@/hooks/useSocket";
import { ESocketEvents } from "@/utils/api/sockets.enum";
import { useEventRoomState } from "@/containers/root-container";
import { eventRoomStore } from "@/stores/event";

const NoiseCancellation: React.FC = () => {
  const eventRoomState = useEventRoomState();
  const { emitEvent } = useSocket();
  const [is_noise_cancellation_feature, setIs_noise_cancellation_feature] =
    useState(eventRoomState.is_noise_cancellation_on);
  const [isUpdating, setIsUpdating] = useState(false);
  // Use ref for synchronous lock to prevent race conditions on rapid clicks
  const isUpdatingRef = useRef(false);

  const NoiseCancellationfeaturehandler = async () => {
    // CRITICAL: Use ref for synchronous check to prevent race conditions
    if (isUpdatingRef.current) {
      return;
    }

    const newValue = !is_noise_cancellation_feature;
    
    try {
      // Set both ref (synchronous) and state (for UI)
      isUpdatingRef.current = true;
      setIsUpdating(true);
      
      // Update local state
      setIs_noise_cancellation_feature(newValue);
      eventRoomStore.updateNoiseCancellation(newValue);

      const userRole = eventRoomState.me.info.role;
      
      // CRITICAL: Only GUIDE modifies their own microphone
      // HOST sends command to GUIDE via socket (doesn't touch their own mic)
      if (userRole === "guide") {
        if (eventRoomStore.rtcClient && eventRoomStore.rtcClient.rtc) {
          await eventRoomStore.rtcClient.rtc.updateNoiseSuppression(newValue);
        }
      }

      // Notify backend via socket (for all roles)
      // This propagates the setting to all participants
      emitEvent(ESocketEvents.IS_NOISE_CANCELLATION_ON, {
        visit_id: eventRoomState.me.channelName,
        is_noise_cancellation_on: newValue,
      });
    } catch (error) {
      console.error("Error updating noise suppression:", error);
      // Revert state on error
      setIs_noise_cancellation_feature(!newValue);
      eventRoomStore.updateNoiseCancellation(!newValue);
    } finally {
      // Unlock both ref (synchronous) and state (for UI)
      isUpdatingRef.current = false;
      setIsUpdating(false);
    }
  };

  useEffect(() => {
    setIs_noise_cancellation_feature(eventRoomState.is_noise_cancellation_on);
  }, [eventRoomState.is_noise_cancellation_on]);

  return (
    <>
      <FormControlLabel
        control={
          <Switch
            className="switch-mode-settings"
            checked={is_noise_cancellation_feature}
            onChange={NoiseCancellationfeaturehandler}
            disabled={isUpdating}
            name="Silent"
          />
        }
        label="Surrounding noise off"
      />
    </>
  );
};
export default NoiseCancellation;
